<template>
  <div ref="chartRef" class="chart"></div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import * as echarts from 'echarts';

const chartRef = ref(null);
let chart = null;

const initChart = () => {
  chart = echarts.init(chartRef.value);

  const option = {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      borderColor: '#5680f9',
      textStyle: {
        color: '#fff',
      },
    },
    legend: {
      data: ['招生人数'],
      textStyle: {
        color: '#fff',
      },
      top: '5%',
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '20%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: [
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        '2026',
        '2027',
        '2028',
        '2029',
        '2030',
      ],
      axisLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.5)',
        },
      },
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 10,
      },
    },
    yAxis: {
      type: 'value',
      name: '人数',
      nameTextStyle: {
        color: 'rgba(255, 255, 255, 0.8)',
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.5)',
        },
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.1)',
        },
      },
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 10,
      },
    },
    series: [
      {
        name: '招生人数',
        type: 'line',
        data: [12605, 13352, 14010, 22739, 23390, 23121, 24213, 22495, 23199, 30299, 26553, 24535],
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: {
          color: '#ff6b6b',
          width: 3,
        },
        itemStyle: {
          color: '#ff6b6b',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(255, 107, 107, 0.6)' },
            { offset: 1, color: 'rgba(255, 107, 107, 0.1)' },
          ]),
        },
      },
    ],
  };

  chart.setOption(option);
};

onMounted(() => {
  initChart();
  window.addEventListener('resize', () => chart?.resize());
});
</script>

<style scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
